import { HttpContextToken, HttpErrorResponse, type HttpInterceptorFn } from '@angular/common/http';
import { throwError, timeout } from 'rxjs';

const DEFAULT_TIMEOUT_MS = 120_000;

export const HTTP_TIMEOUT_MS = new HttpContextToken<number>(() => DEFAULT_TIMEOUT_MS);

export const timeoutInterceptor: HttpInterceptorFn = (request, next) => {
  const timeoutMs = request.context.get(HTTP_TIMEOUT_MS);

  return next(request).pipe(
    timeout({
      each: timeoutMs,
      with: () =>
        throwError(
          () =>
            new HttpErrorResponse({
              status: 504,
              statusText: 'Network timeout',
              url: request.url,
            }),
        ),
    }),
  );
};
